type IconProps = {
  className?: string;
};

export function ChatPatientAvatarIcon({ className = "h-5 w-5" }: IconProps) {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <circle cx="8.33333" cy="5.00002" r="3.33333" fill="#2DD4BF" />
      <ellipse cx="8.33333" cy="14.1666" rx="5.83333" ry="3.33333" fill="#2DD4BF" />
      <path
        d="M13.333 8.08063C13.333 8.90098 14.3037 9.76781 15.0354 10.3047C15.3852 10.5613 15.5601 10.6897 15.833 10.6897C16.1059 10.6897 16.2808 10.5613 16.6306 10.3047C17.3623 9.76782 18.333 8.90099 18.333 8.08062C18.333 6.68627 16.958 6.16568 15.833 7.24281C14.708 6.16568 13.333 6.68627 13.333 8.08063Z"
        fill="#2DD4BF"
      />
    </svg>
  );
}

export function ChatDoctorAvatarIcon({ className = "h-5 w-5" }: IconProps) {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <circle cx="10.0003" cy="5.00002" r="3.33333" fill="#0D9488" />
      <path
        d="M16.6663 14.5833C16.6663 16.6544 16.6663 18.3333 9.99967 18.3333C3.33301 18.3333 3.33301 16.6544 3.33301 14.5833C3.33301 12.5122 6.31778 10.8333 9.99967 10.8333C13.6816 10.8333 16.6663 12.5122 16.6663 14.5833Z"
        fill="#0D9488"
      />
    </svg>
  );
}

export function ChatSendIcon({ className = "h-6 w-6" }: IconProps) {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M4.49746 20.835L21.0072 13.4725C22.3309 12.8822 22.3309 11.1178 21.0072 10.5275L4.49746 3.16496C3.00163 2.49789 1.45006 3.97914 2.19099 5.36689L5.34302 11.2706C5.58817 11.7298 5.58818 12.2702 5.34302 12.7294L2.19099 18.6331C1.45007 20.0209 3.00163 21.5021 4.49746 20.835Z"
        fill="white"
      />
    </svg>
  );
}
